<template>
  <GenericSelector
    :options='sizes'
    :model='model'
    label='Container size'
  />
</template>

<script>
import GenericSelector from './GenericSelector';

export default {
  name: 'ContainerSizeSelector',
  components: {
    GenericSelector,
  },
  data: () => ({
    sizes: [
      '10',
      '20',
      '30',
      '40',
      '45',
      '48',
    ],
  }),
  props: {
    model: {
      type: String,
      default: 'N/A',
      required: false,
    },
  },
};
</script>

<style scoped>

</style>
